// ensure that htese are imported before any other components, so they have an early position in the css load order.
import 'purecss/build/pure.css';
import 'purecss/build/grids-responsive.css';

import React from 'react';
import { createRoot } from 'react-dom/client';
import Analytics from './services/analytics';
import store from 'store';
import App from './app';
import PostHogService from './services/posthog';
import Consent from './services/consent';
import LoginStore from './stores/login-store';

import '../css/font-icons.css';
import '../css/main.scss';

function run() {
  const container = document.getElementById('main');

  // Initialize Google Analytics
  Analytics.init();

  // PostHog starts once the visitor accepts analytics cookies
  Consent.init();
  PostHogService.init();
  LoginStore.watchForUserChanges();

  createRoot(container).render(<App />);

  // Check if store is enabled in browser
  if (!store.enabled) {
    alert('Local storage is not supported by your browser. Please disable "Private Mode", or upgrade to a modern browser.')
    return;
  }
}

// Run the application when both DOM is ready and page content is loaded
if (['complete', 'loaded', 'interactive'].includes(document.readyState) && document.body) {
  run();
} else {
  document.addEventListener('DOMContentLoaded', run, false);
}
